const RateList = () => import(/* webpackChunkName: "PlayerList" */ './containers/RentalGrid.vue');

export const rentalRouting = [
    {path: '/rental', name: 'rental-list', component: RateList},
]
